import { LogOboPayload, UserInfo } from 'models';
import { AnyAction } from 'redux';
import { createActions } from 'reduxsauce';

interface OnBehalfActionTypes {
  SET_IS_ON_BEHALF_OF: 'SET_IS_ON_BEHALF_OF';
  SET_USER_ON_BEHALF_OF: 'SET_USER_ON_BEHALF_OF';
  SET_IS_MANAGER: 'SET_IS_MANAGER';
  SET_PC_ORDER_ON_BEHALF_OF: 'SET_PC_ORDER_ON_BEHALF_OF';
  UPTIME_AUDIT_LOG: 'UPTIME_AUDIT_LOG';
  SET_COUNTRY_CODE_FOR_SOMEONE_ELSE: 'SET_COUNTRY_CODE_FOR_SOMEONE_ELSE';
  SET_IS_ON_BEHALF_OF_NEW_JOINER: 'SET_IS_ON_BEHALF_OF_NEW_JOINER';
  SET_IS_ON_BEHALF_OF_LEAVER: 'SET_IS_ON_BEHALF_OF_LEAVER';
}

interface OnBehalfActions {
  setIsOnBehalfOf: (isOnBehalf: boolean) => AnyAction;
  setIsOnBehalfOfNewJoiner: (isOnBehalfNewJoiner: boolean) => AnyAction;
  setIsOnBehalfOfLeaver: (isOnBehalfLeaver: boolean) => AnyAction;
  setUserOnBehalfOf: (userOnBehalf: UserInfo | null) => AnyAction;
  setIsManager: (isManager: boolean) => AnyAction;
  setPcOrderOnBehalfOf: (pcOrderOBO: any) => AnyAction;
  uptimeAuditLog: (payload: LogOboPayload) => AnyAction;
  setCountryCodeForSomeoneElse: (countryCodeSomeone: string) => AnyAction;
}

const { Types, Creators } = createActions<OnBehalfActionTypes, OnBehalfActions>({
  setIsOnBehalfOf: ['isOnBehalf'],
  setIsOnBehalfOfNewJoiner: ['isOnBehalfNewJoiner'],
  setIsOnBehalfOfLeaver: ['isOnBehalfLeaver'],
  setUserOnBehalfOf: ['userOnBehalf'],
  setIsManager: ['isManager'],
  setPcOrderOnBehalfOf: ['pcOrderOBO'],
  uptimeAuditLog: ['payload'],
  setCountryCodeForSomeoneElse: ['countryCodeSomeone'],
});

export const OnBehalfTypes = Types;
export default Creators;
